// pageCache.js
// Implements a simple LRU cache for PDF page renders.

class PageCache {
  constructor(limit = 500) {
    this.limit = limit;
    this.cache = new Map();
    this.hits = 0;
    this.misses = 0;
    this.errors = 0; // Add tracking for errors
  }

  get(key) {
    const value = this.cache.get(key);
    if (value) {
      this.hits++;
      // Move to end to mark as recently used
      this.cache.delete(key);
      this.cache.set(key, value);
      return value;
    }
    this.misses++;
    return null;
  }

  set(key, value) {
    try {
      // Skip caching if value is invalid
      if (!value) {
        this.errors++;
        return;
      }
      
      // Remove oldest if at limit
      if (this.cache.size >= this.limit) {
        const firstKey = this.cache.keys().next().value;
        this.cache.delete(firstKey);
      }
      this.cache.set(key, value);
    } catch (error) {
      console.warn('Error caching page:', error);
      this.errors++;
    }
  }

  clear() {
    this.cache.clear();
    this.hits = 0;
    this.misses = 0;
    this.errors = 0;
  }

  getStats() {
    return {
      size: this.cache.size,
      hits: this.hits,
      misses: this.misses,
      errors: this.errors,
      hitRate: this.hits / (this.hits + this.misses) || 0
    };
  }

  // Add method to check if a rendering failed due to font issues
  isFontRenderError(error) {
    if (!error) return false;
    
    const errorMsg = error.toString();
    return (
      errorMsg.includes('TT: undefined function:') ||
      errorMsg.includes('glyf table is not found') ||
      errorMsg.includes('Font data is not')
    );
  }
}

// Export a singleton instance
export default new PageCache(50);
